import { hexToArrayBuffer } from './hexToArrayBuffer.js';
/**
 * Converts a UUID string to an ArrayBuffer.
 *
 * @param uuid - The UUID string to convert.
 * @returns The ArrayBuffer representation.
 *
 * @group Utils
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/utils/uuidToArrayBuffer.test.ts#example}
 */
export function uuidToArrayBuffer(uuid) {
    const hex = uuid.replace(/-/g, '');
    return hexToArrayBuffer(hex);
}
//# sourceMappingURL=uuidToArrayBuffer.js.map